import { GeneralSettingsPage } from "@/features/tenants-settings/general-settings";
import { verifyRoles } from "@/utils/verifyRoles";
import { createFileRoute } from "@tanstack/react-router";
import { getTenant } from "../../../../../requests/getTenant";

export const Route = createFileRoute(
  "/dashboard/tenants/$tenantId/(settings)/general-settings",
)({
  component: GeneralSettingsPage,
  head: () => ({
    meta: [
      {
        title:
          "Configurações de dados do servidor de autorização - Backoffice Detentora Iniciador",
      },
    ],
  }),
  beforeLoad: () => verifyRoles(["INIC_ADMIN", "ORG_ADMIN"]),
  loader: async ({ context, params }) => {
    await context.queryClient.prefetchQuery({
      queryKey: ["tenant", params.tenantId],
      queryFn: async () => getTenant(params.tenantId),
    });
  },
});
